import React from "react"
import { useIndividualProfileState } from "../../../IndividualProfileContextProvider"
import {
  FullNameContainer,
  EmailContainer,
  HumanResourceInfoLabel,
  HumanResourceValue,
} from "./style"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { SpacingY } from "@src/components/SpacingY"
import { SpacingX } from "@src/components/SpacingX"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircle } from "@fortawesome/free-solid-svg-icons"

function Dot() {
  return (
    <span
      style={{
        color: "#000 87%",
        fontWeight: "400",
        fontSize: "0.4em",
      }}
    >
      <FontAwesomeIcon icon={faCircle} />
    </span>
  )
}

const BULLET_GAP = "15px"

const IndividualInformation = ({
  label,
  value,
  children,
  showSeparator = true,
}) => {
  if (!value && !children) return null
  return (
    <SpacingX gap={BULLET_GAP} alignItems="center" wrap={false}>
      {showSeparator && <Dot />}
      <SpacingX size="xs">
        <HumanResourceInfoLabel>{label}</HumanResourceInfoLabel>
        <HumanResourceValue>{children ?? value}</HumanResourceValue>
      </SpacingX>
    </SpacingX>
  )
}

export default function IndividualHumanResourceInformation() {
  const { individualData } = useIndividualProfileState()
  const fullName = `${individualData?.first_name || ""} ${individualData?.last_name || ""}`
  const { t } = useTranslation("individualRiskProfile")

  if (!individualData) return null

  return (
    <SpacingY>
      <FullNameContainer>
        {individualData?.first_name ? fullName : null}: {t("profileTitleText")}
      </FullNameContainer>
      <SpacingX gap={BULLET_GAP} alignItems="center">
        <IndividualInformation
          label={t("profileEmailTextLabel")}
          showSeparator={false}
        >
          <EmailContainer href={`mailto:${individualData.email}`}>
            {individualData.email}
          </EmailContainer>
        </IndividualInformation>
        <IndividualInformation
          label={t("individualInformation.position")}
          value={individualData?.job_title}
        />
        <IndividualInformation
          label={t("individualInformation.department")}
          value={individualData?.department}
        />
        <IndividualInformation
          label={t("individualInformation.location")}
          value={individualData?.location}
        />
        {individualData?.manager_name && (
          <IndividualInformation label={t("individualInformation.managedBy")}>
            <Link
              style={{ color: "#1565c0" }}
              to={`/engagement/vision2/${individualData?.es_manager_id}/profile`}
            >
              <span>{individualData?.manager_name}</span>
            </Link>
          </IndividualInformation>
        )}
        <IndividualInformation
          label={t("individualInformation.timezone")}
          value={individualData?.timezone}
        />
      </SpacingX>
    </SpacingY>
  )
}
